const daysWeek = [
  {
    name: "D",
    idDay: 0,
    isSelected: false,
  },
  {
    name: "S",
    idDay: 1,
    isSelected: false,
  },
  {
    name: "T",
    idDay: 2,
    isSelected: false,
  },
  {
    name: "Q",
    idDay: 3,
    isSelected: false,
  },
  {
    name: "Q",
    idDay: 4,
    isSelected: false,
  },
  {
    name: "S",
    idDay: 5,
    isSelected: false,
  },
  {
    name: "S",
    idDay: 6,
    isSelected: false,
  }
];

export default daysWeek;